import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../../components/Header';
import api from '../../api';

export default function Quizzes() {
  const [quizzes, setQuizzes] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    api.get('/quizzes')
      .then(({ data }) => setQuizzes(data.quizzes))
      .catch(err => Swal.fire('Erro', err.response?.data?.error || 'Não foi possível carregar os quizzes.', 'error'))
      .finally(() => setCarregando(false));
  }, []);

  async function excluir(q) {
    if (q.trilhas.length) {
      return Swal.fire({
        icon: 'info', title: 'Esse quiz está em uso',
        text: `Tire ele da trilha antes de excluir: ${q.trilhas.map(t => t.titulo).join(', ')}.`,
      });
    }
    const r = await Swal.fire({
      icon: 'warning', title: `Excluir "${q.titulo}"?`,
      text: 'O quiz some da lista. As notas de quem já fez continuam guardadas.',
      showCancelButton: true, confirmButtonText: 'Sim, excluir', cancelButtonText: 'Cancelar', confirmButtonColor: '#C62828',
    });
    if (!r.isConfirmed) return;
    try {
      await api.delete(`/quizzes/${q.id}`);
      setQuizzes(prev => prev.filter(x => x.id !== q.id));
    } catch (err) {
      Swal.fire('Erro', err.response?.data?.error || 'Não foi possível excluir.', 'error');
    }
  }

  const lista = quizzes.filter(q => !busca.trim() || q.titulo.toLowerCase().includes(busca.trim().toLowerCase()));

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 1000 }}>
        <Link to="/admin" className="doc-voltar"><i className="bi bi-arrow-left"></i> Administração</Link>
        <div className="adm-topo">
          <div>
            <h1>Quizzes</h1>
            <p>Os testes das trilhas. Pra colocar um quiz numa trilha, edite a trilha e adicione o teste.</p>
          </div>
          <Link to="/admin/quizzes/nova" className="btn-centrao"><i className="bi bi-plus-lg me-1"></i> Novo quiz</Link>
        </div>

        <div className="adm-filtros">
          <div className="doc-busca" style={{ flex: 1, marginBottom: 0 }}>
            <i className="bi bi-search"></i>
            <input type="text" placeholder="Buscar quiz…" value={busca} onChange={e => setBusca(e.target.value)} />
            {busca && <button type="button" className="doc-busca-limpar" onClick={() => setBusca('')}>×</button>}
          </div>
        </div>

        {carregando ? <div>Carregando…</div> : (
          <div className="adm-tabela-wrap">
            <table className="adm-tabela">
              <thead>
                <tr><th>Quiz</th><th className="adm-num">Perguntas</th><th className="adm-num">Nota mín.</th><th>Está na trilha</th><th className="adm-num">Resultados</th><th></th></tr>
              </thead>
              <tbody>
                {lista.map(q => (
                  <tr key={q.id}>
                    <td>
                      <strong>{q.titulo}</strong>
                      {q.descricao && <div className="adm-sub">{q.descricao}</div>}
                    </td>
                    <td className="adm-num">{q.qtd_questoes}</td>
                    <td className="adm-num">{q.nota_minima}%</td>
                    <td>
                      {q.trilhas.length
                        ? q.trilhas.map(t => <div key={t.id}><Link className="adm-link" to={`/academia/trilhas/${t.id}`}>{t.titulo}</Link></div>)
                        : <span className="adm-badge adm-badge--neutro">fora de trilha</span>}
                    </td>
                    <td className="adm-num">
                      {q.tentativas} tentativa(s)
                      <div className="adm-sub">{q.aprovados} aprovado(s)</div>
                    </td>
                    <td>
                      <div className="adm-acoes">
                        <Link className="adm-btn-icone" title="Editar" to={`/admin/quizzes/${q.id}/editar`}><i className="bi bi-pencil"></i></Link>
                        <button className="adm-btn-icone adm-btn-icone--perigo" title="Excluir" onClick={() => excluir(q)}><i className="bi bi-trash"></i></button>
                      </div>
                    </td>
                  </tr>
                ))}
                {lista.length === 0 && <tr><td colSpan={6} className="adm-vazio">Nenhum quiz encontrado.</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </>
  );
}
